import { TextSmall } from '@/components/Texts';
import Link from 'next/link';
import { useRouter } from 'next/router';

const NameAndAddress = () => {
  const router = useRouter();
  return (
    <>
      <TextSmall fontWeight={700}>
        (2) Name and address of the controller
      </TextSmall>

      <TextSmall>
        We are the controller for the processing of your personal data within
        the meaning of Art. 4 No. 7 GDPR:
      </TextSmall>
      <TextSmall>
        <TextSmall as={'span'} fontWeight={700}>
          Diment
        </TextSmall>
        {/* <br />
        First Floor Almas Tower, Jumeirah Lakes Towers, PO Box 371653 Dubai,
        <br />
        United Arab Emirates
        <br /> */}
        <Link href='mailto:support@diment.io' style={{ color: 'blue' }}>
          support@diment.io
        </Link>
      </TextSmall>
      <TextSmall>
        For further information about our company, please refer to the imprint
        details on our website{' '}
        <TextSmall
          as={'span'}
          color={'blue'}
          _hover={{ cursor: 'pointer' }}
          onClick={() => router.push('/imprint')}
        >
          here
        </TextSmall>
      </TextSmall>
    </>
  );
};

export default NameAndAddress;
